export const LOADED = "posts/load";